import React from "react";
import { Result, Button } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { logout } from "../services/authService";

const PendingApproval = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/sign-in");
  };

  return (
    <Result
      status="info"
      title="Pending Admin Approval"
      subTitle="Your account is pending approval from a Super Admin. You will be notified once your access has been granted."
      extra={[
        <Button key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
          Logout
        </Button>,
      ]}
    />
  );
};

export default PendingApproval;
